import * as React from "react"

function Waarning(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.94984 8.0002C1.94984 4.65887 4.65851 1.9502 7.99982 1.9502C11.3411 1.9502 14.0498 4.65887 14.0498 8.0002C14.0498 11.3415 11.3411 14.0502 7.99982 14.0502C4.65851 14.0502 1.94984 11.3415 1.94984 8.0002ZM7.99987 5.00569C8.30363 5.00569 8.54987 5.25193 8.54987 5.55569V8.30569C8.54987 8.60945 8.30363 8.85569 7.99987 8.85569C7.69612 8.85569 7.44988 8.60945 7.44988 8.30569V5.55569C7.44988 5.25193 7.69612 5.00569 7.99987 5.00569ZM8.61091 10.4446C8.61091 10.7821 8.33731 11.0557 7.9998 11.0557C7.66229 11.0557 7.38869 10.7821 7.38869 10.4446C7.38869 10.1071 7.66229 9.83347 7.9998 9.83347C8.33731 9.83347 8.61091 10.1071 8.61091 10.4446Z" fill={props?.fill ?? "#A7B5C8"} />
    </svg>
  )
}

export default Waarning
